import { useSiteText } from "../site/i18n";
import { lazy, Suspense } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import routes from "./config";
import { Navigation } from "../site/components/Navigation";
import { Footer } from "../site/components/Footer";
import { PageEffects } from "../site/components/PageEffects";
import "../site/site.css";

// Create lazy components once so navigation state never remounts the page.
const resolvedRoutes = routes.map((route) => ({
  ...route,
  Page: route.modern
    ? lazy(() => import(`../site/pages/${route.component}`))
    : lazy(() => import(`../pages/${route.component}`)),
}));
const UseCaseIndex = lazy(() =>
  import("../site/pages/UseCases").then((module) => ({
    default: module.UseCaseIndex,
  })),
);
const NotFound = lazy(() => import("../site/pages/NotFound"));

export default function Router() {
  const txt = useSiteText();
  const location = useLocation();
  const legacy = /^\/(policy|terms|imprint|success|cancel)\/?$/i.test(
    location.pathname,
  );
  return (
    <div className="systein-site">
      <a className="skip-link" href="#main-content">
        {txt("Skip to content")}
      </a>
      <PageEffects />
      <Navigation />
      <main
        id="main-content"
        tabIndex={-1}
        className={legacy ? "legacy-content" : undefined}
      >
        <Suspense
          fallback={
            <div className="page-loading container" role="status">
              {txt("Loading Systein…")}
            </div>
          }
        >
          <Switch>
            <Route
              exact
              path="/Home"
              render={() => (
                <Redirect
                  to={{
                    pathname: location.hash === "#contact" ? "/contact" : "/",
                    hash: location.hash === "#contact" ? "" : location.hash,
                    search: location.search,
                  }}
                />
              )}
            />
            <Route exact path="/use-cases" component={UseCaseIndex} />
            {resolvedRoutes.map(({ Page, ...route }) => (
              <Route
                key={route.component}
                path={route.path}
                exact={route.exact}
                component={Page}
              />
            ))}
            <Route component={NotFound} />
          </Switch>
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}
